import React from 'react';
import PropTypes from 'prop-types';

import { InfoField } from '../../info-field';
import { InnerSection } from './inner-section';

const AgentInformation = ({ agentName, agentEmail }) => (
  <InnerSection title="Agent information">
    <InfoField label="Agent name" value={agentName} xs={4} />
    <InfoField label="Agent email" value={agentEmail} xs={8} />
  </InnerSection>
);

AgentInformation.propTypes = {
  agentName: PropTypes.string,
  agentEmail: PropTypes.string
};

AgentInformation.defaultProps = {
  agentName: null,
  agentEmail: null
};

export default AgentInformation;
